import { Navigate, Link } from "react-router-dom";
import { Shield, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export const AdminShell = ({ children, title }) => {
  const { user, logout } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0F172A] text-sm text-slate-400">
        Checking session…
      </div>
    );
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0F172A]" data-testid="admin-header">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-6">
          <Link to="/admin" className="flex items-center gap-2 text-white">
            <Shield size={18} className="text-[#4687FF]" fill="#4687FF" fillOpacity={0.25} />
            <span className="font-display text-sm font-extrabold tracking-tight">
              VPNReviews<span className="text-[#4687FF]">.ai</span>
              <span className="ml-2 rounded bg-white/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-slate-300">Admin</span>
            </span>
          </Link>
          <div className="flex items-center gap-5">
            <a href="/" target="_blank" rel="noreferrer" className="text-xs font-semibold text-slate-300 hover:text-white">
              View site ↗
            </a>
            <button
              onClick={logout}
              data-testid="admin-logout-btn"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-300 hover:text-white"
            >
              <LogOut size={14} /> Log out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10">
        {title && <h1 className="mb-8 font-display text-3xl font-black tracking-tighter text-[#0F172A]">{title}</h1>}
        {children}
      </main>
    </div>
  );
};
